import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { safeRequestParam } from 'src/utils/Common';
import logger from 'src/utils/logger';

function ProductMaterialSearch({ setMalzeme, value, searchParam, searchProductCode }) {
    const [openMalzeme, setOpenMalzeme] = React.useState(false);
    const [optionsMalzeme, setOptionsMalzeme] = React.useState([]);
    const loadingMalzeme = openMalzeme && optionsMalzeme.length === 0;
    const [searchMalzeme, setSearchMalzeme] = React.useState('');
    const [searchUrun, setSearchUrun] = React.useState('');

    React.useEffect(() => {
        let active = true;

        // ŞART: Ya kullanıcı bir şeyler yazıyor ve rehber açık (Normal çalışma)
        // VEYA: searchParam -1 gelmiş (Senin istediğin özel durum)
        const isSpecialSearch = searchParam === -1 || searchParam === "-1";
        const isUserTyping = searchMalzeme.length > 0 && openMalzeme;

        if (isUserTyping || isSpecialSearch) {
            // Eğer özel arama ise ve searchMalzeme henüz dolmadıysa searchParam'ı veya varsayılanı kullan
            const mParam = isSpecialSearch && searchMalzeme.length === 0 ? searchParam : searchMalzeme;

            axios.get('/GetArtemisProductMaterials/' + safeRequestParam(mParam.toString())+ '/' + safeRequestParam(searchProductCode.toString().toLocaleLowerCase('tr-TR')))
                .then(res => {
                    if (active) {
                        if (res.data && res.data.length > 0) {
                            setOptionsMalzeme(res.data);
                        } else {
                            setOptionsMalzeme([]);
                        }
                    }
                }).catch(error => {
                    setOptionsMalzeme([]);
                    logger.error("Hata detayı:", error.message);
                });
        }

        return () => {
            active = false;
        };
        // Dependency listesine searchParam'ı da ekledik ki değiştiğinde tetiklensin
    }, [searchMalzeme, openMalzeme, searchUrun, searchParam, searchProductCode]);

    React.useEffect(() => {
        // Mevcut mantığınızı koruyoruz
        if (searchParam && searchParam.toString().length > 0 && searchProductCode === '0') {
            setSearchMalzeme(searchParam);
            setSearchUrun(searchProductCode);
        }
        if (searchParam && searchParam.toString().length < 1 && searchProductCode !== '0') {
            setSearchMalzeme("0");
            setSearchUrun(searchProductCode);
        }
    }, [searchParam, searchProductCode]);

    const updateMalzeme = malzeme => {
        // 1. Önce parent bileşene seçilen objeyi gönderiyoruz
        setMalzeme(malzeme);

        // 2. Eğer "value" bir obje ise içindeki alanları güncelliyoruz.
        // Hata buradaydı: value bazen "-1" geliyordu ve üstüne property yazılamıyordu.
        if (value && typeof value === 'object') {
            value.ACIKLAMA = malzeme.ACIKLAMA;
            value.MALZEME_STOK_NO = malzeme.MALZEME_STOK_NO;
        }
    }

    return (
        <Autocomplete
            id="asynchronous-demo"
            open={openMalzeme}
            value={value}
            onOpen={() => setOpenMalzeme(true)}
            onClose={() => setOpenMalzeme(false)}
            getOptionLabel={(option) => option.MALZEME_STOK_NO ? (option.MALZEME_STOK_NO + ' - ' + option.ACIKLAMA) : '-'}
            options={optionsMalzeme}
            filterOptions={(options) => options} // Sunucu tarafı filtreleme olduğu için client filter'ı devre dışı bırakıyoruz
            loading={loadingMalzeme}
            onChange={(event, newValueMalzeme) => {
                if (newValueMalzeme) {
                    updateMalzeme(newValueMalzeme);
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    onChange={e => setSearchMalzeme(e.target.value)}
                    variant="outlined"
                    helperText={value ? value.ACIKLAMA : ''}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loadingMalzeme ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}

export default ProductMaterialSearch;